<template>
  <div class="EditTemperatureWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="EditTemperatureWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="EditTemperatureWidget-main lxn-pos-rel">
      <div class="EditTemperatureWidget-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.EditWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="EditTemperatureWidget-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="EditTemperatureWidget-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="EditTemperatureWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="EditTemperatureWidget-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="EditTemperatureWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="EditTemperatureWidget-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="EditTemperatureWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="EditTemperatureWidget-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="EditTemperatureWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="EditTemperatureWidget-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="EditTemperatureWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="EditTemperatureWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Name_text}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="WidgetName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.WidgetName_PlaceHolder" inputType="text" />
            </div>
            <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Folder_text}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetFolder" :dropDownContex="dropDownTargetFolder" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddTemperatureWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="EditTemperatureWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.ChooseHub_text}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
            <div class="EditTemperatureWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureWidget_text1}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetOutput" :dropDownContex="dropDownTargetOutputs" />
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="EditTemperatureWidget-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.Save_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'


export default {
  name: 'EditTemperatureWidget',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    DropDown,
  },
  data: function () {
    return {
      widget: this.$store.state.widgets[this.$route.params.widgetIndex],
      WidgetName: '',
      input1State: '',
      activeBoxIndex: 0,
      targetHub: this.$store.getters.getHubByUUID(this.$store.state.widgets[this.$route.params.widgetIndex].hubUUID).index,
      outputList: [],
      targetOutput: 0,
      targetFolder: 0,
      folderList: [],
    }
  },
  mounted: function () {
    this.WidgetName = this.widget.name;
    this.activeBoxIndex = this.widget.color;
    this.targetHub = this.$store.getters.getHubByUUID(this.widget.hubUUID).index;

    for(var i = 0; i < this.outputList.length; i++){
      if(this.outputList[i].node.uuid == this.node.uuid && this.outputList[i].outputIndex == this.widget.settings.inputIndex){
        this.targetOutput = i;
      }
    }

    for(let i = 0; i < this.folderList.length; i++){
      if(this.folderList[i].path == this.widget.path){
        this.targetFolder = i;
      }
    }
  },
  watch: {
    targetHub: function (){
      this.targetOutput = 0;
    },
  },
  computed: {
    node: function () {
      return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownTargetOutputs: function () {
      this.outputListCleaner();
      var dropDownTargetOutputs = {
        name: "EditTemperatureWidget-TargetOutputs",
        title: this.$store.getters.language.texts.ChooseOutput_text,
        selectedIndex: this.targetOutput,
        data: []
      };
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        if(this.$store.state.hubs[this.targetHub].uuid == this.$store.state.nodes[i].hubUUID){
          for(var j = 0; j < this.$store.state.nodes[i].inputs.length; j++){
            if(this.$store.state.nodes[i].inputs[j].type == "temperatureSensor"){
              this.outputListSetter(
                {
                  node: this.$store.state.nodes[i],
                  output: this.$store.state.nodes[i].inputs[j],
                  outputIndex: j,
                }
              );
              dropDownTargetOutputs.data.push({
                name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].inputs[j].name,
                icon: this.$store.state.nodes[i].inputs[j].icon,
              })
            }
          }
        }
      }
      return dropDownTargetOutputs;
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "EditTemperatureWidget-TargetHubs",
        title: this.$store.getters.language.texts.ChooseHub_text,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
    dropDownTargetFolder: function () {
      this.folderListCleaner();
      var dropDownTargetFolder = {
        name: "AddSingleSwitchWidget-TargetOutputNoNc",
        title: this.$store.getters.language.texts.ChooseOutput_text,
        selectedIndex: this.targetFolder,
        data: [
          {
            name: this.$store.getters.language.texts.Root_text,
            icon: 'folder',
          },
        ]
      };
      this.folderListSetter(
        {
          widgetIndex: -1,
        }
      );
      for(var i = 0; i < this.$store.state.widgets.length; i++){
        if(this.$store.state.widgets[i].type == "folderWidget"){
          var folderWidget = this.$store.state.widgets[i];
          var parentPath = folderWidget.settings.parent;
          var parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          var folderName = folderWidget.name;
          while(parentFolder.length){
            folderName = parentFolder[0].name + " > " + folderName;
            parentPath = parentFolder[0].settings.parent;
            parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          }
          this.folderListSetter(
            {
              path: folderWidget.settings.path,
            }
          );
          dropDownTargetFolder.data.push({
            name: folderName,
            icon: "folder",
          })
        }
      }
      return dropDownTargetFolder;
    },
  },
  methods: {
    folderListSetter: function (obj) {
      this.folderList.push(obj);
    },
    folderListCleaner: function () {
      this.folderList = [];
    },
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    outputListCleaner: function () {
      this.outputList = [];
    },
    outputListSetter: function (obj) {
      this.outputList.push(obj);
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.WidgetName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.WidgetName_alert);
      }else if(this.outputList.length == 0){
        alert(this.$store.getters.language.texts.NoOutPutForHub_alert);
      }else{
        this.$store.commit('setAppBusy', true);
        var nodeUUIDs = [this.outputList[this.targetOutput].node.uuid];
        var inputIndex = this.outputList[this.targetOutput].outputIndex;
        var hubUUID = this.outputList[this.targetOutput].node.hubUUID;
        var path = this.folderList[this.targetFolder].path;

        var widget = {
          name: this.WidgetName,
          color: this.activeBoxIndex,
          type: "temperatureWidget",
          hubUUID: hubUUID,
          nodeUUIDs: nodeUUIDs,
          visible: true,
          path: path,
          settings: {
            inputIndex: inputIndex,
          }
        }
        this.$store.commit('editWidget', {
          widgetIndex: this.$route.params.widgetIndex,
          widget: widget,
        });
        this.$store.commit('saveState');
        this.$router.push('/home/dashboard/');
        this.$store.commit('setAppBusy', false);
      }

    },
  }
}
</script>

<style>
  .EditTemperatureWidget-topCurve-wrapper {
    height: 200px;
  }
  .EditTemperatureWidget-main {
    z-index: 2;
  }
  .EditTemperatureWidget-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .EditTemperatureWidget-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .EditTemperatureWidget-wrapper-colors {
    height: 50px;
  }
  .EditTemperatureWidget-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .EditTemperatureWidget-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .EditTemperatureWidget-color.active .EditTemperatureWidget-selectedColor {
    opacity: 1;
  }
  .EditTemperatureWidget-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .EditTemperatureWidget-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .EditTemperatureWidget-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .EditTemperatureWidget-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .EditTemperatureWidget-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .EditTemperatureWidget-commandDelay-button:hover {
    opacity: 0.5;
  }
  .EditTemperatureWidget-commandDelay-button:hover {
    opacity: 0.5;
  }
  .EditTemperatureWidget-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .EditTemperatureWidget-wrapper-button2 {
    width: calc(100% - 36px);
    margin-top: 25px;
    margin-bottom: 14px;
  }
  .EditTemperatureWidget-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .EditTemperatureWidget-wrapper-commands:first-child {
    margin-top: 0;
  }
  .EditTemperatureWidget-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .AddSingleSwitchWidget-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
